<template>
  <div class="crm-visitlist">
    <div class="crm-visitlist-body-scroll">
      <div class="showTitle"
      ><p>共{{ list.length }}条</p>
        <p @click="showPopup">筛选
          <van-icon name="brush-o"/>
        </p
        >
      </div>
      <van-pull-refresh v-model="visitScroll.refreshing" @refresh="onRefresh">
        <van-list v-model="visitScroll.loading" :finished="visitScroll.finished" finished-text="没有更多了"
                  @load="OnLoadScroll">
          <template v-for="(item, index) in list">
            <template v-if="item.type === 1">
              <van-cell :key="index" :label="`${ item.createBy }  ${ item.visitTime }`" >
                <template #title>
                  <div>
                    <van-tag color="#5f5aa3">{{ item.visitType_dictText }}</van-tag>
                  </div>
                  <div class="visit-cell-title">{{ item.content }}</div>
                </template>
              </van-cell>
            </template>
            <template v-else>
              <van-cell :key="index" center is-link value="详情" :label="`${ item.createBy }  ${ item.visitTime }`" @click="routerPush('/crm/firstVisit-hospital')">
                <template #title>
                  <div>
                    <van-tag color="#5f5aa3">入院首次探访</van-tag>
                  </div>
                  <div class="visit-cell-title">入院首次，探访点击查看详情</div>
                </template>
              </van-cell>
            </template>
          </template>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-popup class="crm-vist-popup" v-model="show">
      <van-row>
        <van-col class="popup-title">类型筛选</van-col>
      </van-row>
      <van-row class="popup-row">
        <van-col class="popup-col" v-for="item in visitList" :key="item.value">
          <van-tag @click="select(item.value)" color="#5f5aa3" size="large" :plain="item.visitRadio" type="primary">
            {{item.title}}
          </van-tag>
        </van-col>
      </van-row>
      <van-row class="popup_ok">
        <van-button color="#5f5aa3" size="small" @click="onSearch()">确定</van-button>
      </van-row>
    </van-popup>

    <div class="bottom-operation" v-if="showOperationButtons">
      <div class="operation-btn" @click="handleShowNormal">
        普通探访
      </div>

      <div
          class="operation-btn"
          @click="routerPush('/crm/firstVisit-hospital')"
      >
        入院首次探访
      </div>
    </div>

    <!-- 普通探访 -->
    <OrdinaryVisit
        :hospitalId="inWardFrom.id"
        :patientId="inWardFrom.patientId"
        :showNormalPopup="showNormalPopup"
        v-if="showNormalPopup"
        @ok="() => { okVisit() }"
        @close="() => { cancelVisit() }"
    />

    <div class="bottom-operation2">
      <div v-if="showAddButton" class="add-btn" @click="changeOperationButtons">
        <van-icon name="plus" class="add-icon"/>
      </div>
    </div>

    <!-- 日期选择器弹窗 -->
    <van-popup v-model="showDatePicker" position="bottom" :style="{ height: '360px' }">
      <van-datetime-picker
          v-model="visitForm.visitTime"
          type="date"
          @confirm="handleDateConfirm"
          @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import crmMixins from "@/utils/crm-mixins";
import SexIcon from "@/components/CRM/SexIcon";
import dayjs from "dayjs";
import OrdinaryVisit from "@/views/CRM/InHospitalList/OrdinaryVisit/index";
import { Notify, Popup, DatetimePicker, Field } from "vant";
import TextOverflow from "@/views/CRM/Patient/TextOverflow.vue";
import request from "@/request";


export default {
  name: "crm-visitList",
  mixins: [crmMixins],
  components: {
    OrdinaryVisit,
    SexIcon,
    TextOverflow,
    VanPopup: Popup,
    VanDatetimePicker: DatetimePicker,
    VanField: Field
  },
  props: {
    inWardFrom: Object, upData: Number
  },
  data() {
    return {
      dayjs,
      visitScroll: {
        loading: false,
        finished: false,
        refreshing: false
      },
      show: false,
      applyList: [],
      url: {
        list: "/crm-service/crm/crmVisit/groupByAll"
      },
      queryParams: {
        column: "visitTime",
        order: "desc",
        visitTypeQuery: -1,
        patientId: this.inWardFrom.patientId
      },
      statusList: [],
      applyId: "",
      zjh: "",
      visitList: [
        {
          text: "全部",
          title: "全部",
          value: "-1",
          visitRadio: true
        }
      ],
      showOperationButtons: false,
      showNormalPopup: false,
      showAddButton: true,
      visitForm: {
        visitObject: "患者",
        visitTime: "",
        visitContent: ""
      },
      showDatePicker: false
    };
  },
  mounted() {
    // this.visit_type.map((item) => {
    // 	this.$set(item, "visitRadio", true);
    // });
    // this.visitList = this.visitList.concat(this.visit_type);this.loadPage();
  },
  watch: {
    // 监听 myData 的变化
    upData(newVal, oldVal) {
      console.log("myData 改变了: ", newVal, "（之前是：", oldVal, "）");
      if (newVal != oldVal) {
        this.refreshData();
      }

    }
  },
  methods: {
    routerPush(url) {
      const { inWardFrom } = this;
      this.$store.dispatch("setFirstVisitSurveyHospitalApplyData", inWardFrom);
      this.$router.push({ path: url, query: { id: inWardFrom.id } });
    },
    refreshData() {
      this.visit_type.map((item) => {
        this.$set(item, "visitRadio", true);
      });
      this.visitList = this.visitList.concat(this.visit_type);
      this.loadPage();
    },
    showPopup() {
      this.show = true;
      console.log("that.visitList", this.visitList);
    },
    select(value) {
      let that = this;
      that.visitList.map((i) => {
        if (value == i.value) {
          i.visitRadio = !i.visitRadio;
          that.queryParams.visitTypeQuery = i.value;
        } else {
          i.visitRadio = true;
        }
      });
    },
    onSearch() {
      this.show = false;
      this.OnLoadScroll();
    },
    onRefresh() {
      this.visitScroll = {
        loading: true,
        finished: false,
        refreshing: true
      };
      this.OnLoadScroll();
    },
    OnLoadScroll() {
      // this.showLoading('')
      return request.get(this.url.list, { params: { ...this.queryParams } }).then(res => {
        const result = res.result;
        if (res.success && (res.code === 200 || res.code === 0)) {
          this.list = result;
          this.visitScroll = {
            loading: false,
            finished: true,
            refreshing: false
          };
        } else {
          this.visitScroll.finished = true;
          Notify({ type: "danger", message: res.message });
        }
        return res;
      });
    },

    changeOperationButtons() {
      this.showOperationButtons = !this.showOperationButtons;
    },

    handleShowNormal() {
      this.showNormalPopup = !this.showNormalPopup;
      this.showOperationButtons = !this.showOperationButtons;
      this.showAddButton = !this.showAddButton;
    },

    showDatePickerPopup() {
      this.showDatePicker = true;
    },
    handleDateConfirm(date) {
      // 格式化日期为 YYYY-MM-DD
      this.visitForm.visitTime = dayjs(date).format("YYYY-MM-DD");
      this.showDatePicker = false;
    },
    submitVisit() {
      //校验表单
      if (!this.visitForm.visitTime || !this.visitForm.visitContent) {
        this.$toast("请完善表单内容");
        return;
      }
      //提交表单,逻辑暂时不写
      console.log("提交探访表单", this.visitForm);
      //成功后关闭弹窗
      this.showNormalPopup = false;
      //显示操作按钮
      this.showOperationButtons = false;
      this.showAddButton = true;
      //重置表单
      this.visitForm = {
        visitObject: "患者",
        visitTime: "",
        visitContent: ""
      };
      this.$toast("提交成功");
    },
    cancelVisit() {
      //关闭弹窗
      this.showNormalPopup = false;
      //显示操作按钮
      this.showOperationButtons = false;
      this.showAddButton = true;
      //重置表单
      this.visitForm = {
        visitObject: "患者",
        visitTime: "",
        visitContent: ""
      };
    },
    okVisit () {
      this.$toast.success("提交成功");
      setTimeout(() => {
        this.cancelVisit()
        this.refreshData()
      }, 500)
    }
  }
};
</script>

<style lang="less">

.crm-vist-popup {
  .popup_ok {
    text-align: right;
    margin-top: 20px;
  }

  padding: 80px 50px;
  width: 80vw;
  border-radius: 10px;

  .popup-title {
    font-size: 32px;
    font-weight: 600;
    line-height: 22px;
    margin-bottom: 20px;
  }
}

.crm-visitlist .showTitle {
  // margin-top: 2px;
  background-color: #fff;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0.533rem 0.1rem;

  p {
    color: #969799;
    text-align: left;
    font-weight: 400;
    font-size: 0.647rem;
    line-height: 1.04rem;
    margin-bottom: 0rem;
  }
}

.popup-row {
  .popup-col {
    width: 33%;
    padding-top: 40px;

    span {
      width: 100%;
      justify-content: center;
    }

    &:nth-child(3n + 1) {
      padding-right: 10px;
    }

    &:nth-child(3n + 2) {
      padding-left: 5px;
      padding-right: 5px;
    }

    &:nth-child(3n + 3) {
      padding-left: 10px;
    }
  }
}

.visit-cell-title {
  padding-right: 10px;
}

.crm-visitlist {
  text-align: left;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 6rem;

  .title-class {

    //.title-class-name {
    //  padding-right: 0.5rem;
    //}
    //.title-class-time {
    //  padding-right: 0.5rem;
    //}
  }

  .visit-time {
    //margin-top: 4px;
    //color: #969799;
    //font-size: 12px;
    //line-height: 18px;
    .visit-time-span {
      padding-right: 0.5rem;
      color: #969799;
      font-size: 0.647rem;
    }
  }

  .expanded-btn {
    background-color: #fff;
  }
}

.bottom-operation {
  width: 220px;
  height: 260px;
  position: fixed;
  right: 0;
  bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 20px;
  z-index: 9999;
}

.operation-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  width: 200px;
  height: 60px;
  border-radius: 25px;
  border: 2px solid #1e1f22;
  font-size: 29px;
  color: #5f5aa2;
  background-color: #ffffff;
}

.bottom-operation2 {
  width: 120px;
  height: 100px;
  position: fixed;
  right: 0;
  bottom: 30px;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 20px;
  z-index: 9999;
}

.add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50px;
  background-color: #5f5aa2;
  position: absolute;
  bottom: 0;

  .add-icon {
    color: #ffffff;
    font-size: 35px;
  }

}

.visit-popup {
  padding: 40px;
  width: 700px;

  .form-item {
    margin-bottom: 50px;
    display: flex;
    flex-direction: row;
    white-space: nowrap;

    .form-label {
      font-size: 28px;
      white-space: nowrap;
    }

    .custom-radio-group {
      display: inline-block;

      .inline-radio {
        display: inline-flex;
        align-items: center;
        margin-left: 20px;
      }
    }

    .time-picker {
      width: 260px;
      height: 50px;
      border: 1px solid #1e1f22;
      border-radius: 15px;
      margin-left: 15px;
      margin-top: -5px;
      display: flex;
      justify-content: center;
      align-items: center;

      input.van-field__control {
        font-size: 26px;
        text-align: center;
      }
    }

    .content-input {
      border: 1px solid #1e1f22;
      border-radius: 15px;
      margin-left: 15px;
      margin-top: -5px;
      padding: 14px;

      .van-field__control {
        font-size: 27px;
      }
    }
  }

  .form-item2 {
    margin-bottom: 0px;

    .form-cancel {
      display: flex;
      justify-content: left;
      align-items: center;
      width: 50%;
      margin-left: 10px;

      .van-button {
        height: 100%;
        width: 150px;
        border-radius: 15px;
      }
    }

    .form-submit {
      display: flex;
      justify-content: right;
      align-items: center;
      width: 50%;
      height: 60px;
      margin-right: 7px;

      .van-button {
        height: 100%;
        width: 150px;
        border-radius: 15px;
      }
    }
  }


}

</style>
